import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {
  MatInputModule, MatButtonModule, MatCheckboxModule, MatCardModule, MatIconModule,
  MatProgressSpinnerModule,
  MatFormFieldModule,
  MatSnackBarModule,
  MatToolbarModule,
  MatTabsModule,
  MatChipsModule,
  MatDividerModule,
  MatOptionModule,
  MatSelectModule,
  MatDatepickerModule,
  MatSlideToggleModule,
  MatAutocompleteModule,
  MatDialogModule,
  MatTableModule,
  MatPaginatorModule,
  MatExpansionModule,
  MatButtonToggleModule,
  MatMenuModule,
  MatRadioModule
} from '@angular/material';
import { FlexLayoutModule } from '@angular/flex-layout';
import { ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { MatMomentDateModule } from "@angular/material-moment-adapter";
import { NgxDatatableModule } from '@swimlane/ngx-datatable';


@NgModule({
  imports: [
    CommonModule, MatInputModule, MatButtonModule, MatCheckboxModule, MatCardModule, MatIconModule, MatProgressSpinnerModule,
    MatInputModule, MatFormFieldModule, MatSnackBarModule, MatToolbarModule, MatTabsModule, MatChipsModule, MatDividerModule,
    MatOptionModule, MatSelectModule, FlexLayoutModule, ReactiveFormsModule, TranslateModule, MatDatepickerModule, MatMomentDateModule,
    MatSlideToggleModule, MatAutocompleteModule, MatDialogModule, MatTableModule, MatPaginatorModule, MatExpansionModule,
    NgxDatatableModule, MatButtonToggleModule, MatMenuModule, MatRadioModule
  ],
  exports: [MatButtonModule, MatInputModule, MatCheckboxModule, MatCardModule, MatIconModule, MatProgressSpinnerModule,
    MatInputModule, MatFormFieldModule, MatSnackBarModule, MatToolbarModule, MatTabsModule, MatChipsModule, MatDividerModule,
    MatOptionModule, MatSelectModule, FlexLayoutModule, ReactiveFormsModule, TranslateModule, MatDatepickerModule, MatMomentDateModule,
    MatSlideToggleModule, MatAutocompleteModule, MatDialogModule, MatTableModule, MatPaginatorModule, MatExpansionModule,
    NgxDatatableModule, MatButtonToggleModule, MatMenuModule, MatRadioModule]
})
export class AppMaterialModule { }
